<template>
	<div class="aboutus">
		<changeNav />
		<Carousel>
			<template slot="titleTxt">
				<div class="title-box">
					<img src="~@/assets/image/aboutus.png" alt="" width="94" height="23" class="title-img" />
					<span class="title-txt">About US</span>
				</div>
			</template>
		</Carousel>
		<Breadcrumb />
		<section class="aboutus_top">
			<div class="aboutus_title">福建省越盛智能科技有限公司</div>
			<div class="aboutus_content">
				福建省越盛智能科技有限公司成立于2018年2月1日，是一家专业的工业智能化系统工程设备提供商。公司自创立起，便致力于智能化物流管控称重系统、智能化自动配料系统、
				全生产工艺动态模拟显示和集中操作、数据采集管理等方面，积累了丰富的经验，完成了多项大型DCS、PCS系统工程及配料自控工程。通过艰苦摸索，深入挖掘，我们成功开发
				了大型养殖客户自动喂料系统、上市涂料客户智能助剂系统、央企冶金客户智能视觉系统，截至2021年2月，公司拥有越盛智能喂料称重管理系统V1.0、智能提货管理系统V1.0、
				越盛板面质量检测系统V1.0等多项软件著作权。公司主要从事于化工、仓储、码头、食品、违材、冶金等多个领域的前期规划设计、设备选型、过程控制设计、项目施工等工作。<br/>
				公司在养殖行业、涂料行业、砂石行业、冶金行业均与客户建立了紧密的合作关系，经营范围包括：电子智能化技术、工业自动化技术、计算机领域内的技术开发、技术转让、技术咨询、
				技术服务；计算机软硬件开发；信息系统集成服务等。我们将遵循“精准、高效、全面、公平”的宗旨，以海纳百川的胸怀，以创新变革的勇气，以创业奋斗的精神，为客户创造价值，为员工创造机会，
				为社会创造效益。
			</div>
			<!-- <div class="aboutus_content">
				展战略，旨在将福能医疗做成生命托付的事业、高尚的事业、光荣的事业。
			</div> -->
			<!-- <div class="aboutus_img ">
				<el-image :src="require('@/assets/image/aboutus_img1.png')" style="width: 830;height: 381" class="showdow">
					<div slot="placeholder" class="image-slot">
						<img src="~@/assets/image/nulldefalut.png" alt="" width="830" height="381" class="" />
					</div>
					<div slot="error" class="image-slot">
						<img src="~@/assets/image/nulldefalut.png" alt="" width="830" height="381">
					</div>
				</el-image>
			</div> 
			<div class="aboutus_subtitle">战略规划</div>
			<div class="strategy">
				<img src="~@/assets/image/aboutus_img_27.png" alt="" width="163" height="37" class="strategy-img strategy-img1" />
				<img src="~@/assets/image/aboutus_img_28.png" alt="" width="163" height="37" class="strategy-img strategy-img2" />
				<img src="~@/assets/image/aboutus_img_29.png" alt="" width="163" height="37" class="strategy-img strategy-img3" />
				<img src="~@/assets/image/aboutus_img_30.png" alt="" width="163" height="37" class="strategy-img strategy-img4" />
				<img src="~@/assets/image/aboutus_img_26.png" alt="" width="322" height="401" class="" />
				<div class="strategy-left">
					<span class="strategy-text strategy-text1">1<font class="danwei">个</font></span>
					<span class="strategy-text strategy-text2">10<font class="danwei">个</font></span>
					<span class="strategy-text strategy-text3">100<font class="danwei">个</font></span>
					<span class="strategy-text strategy-text4">1000<font class="danwei">个</font></span>
				</div>
				<div class="strategy-right">
					<div class="strategy_txt strategy_txt_1">福能总医院+互联网的健康平台</div>
					<div class="strategy_txt strategy_txt_2">特色专科医院（其中包含福能心理）</div>
					<div class="strategy_txt strategy_txt_3">专科门店（医学中心）</div>
					<div class="strategy_txt strategy_txt_4">基层医疗网点（云诊所）</div>
				</div>
			</div> -->
		</section>
		<section class="aboutus_bottom">
			<div class="aboutus_bottom_container">
				<h2 class="aboutus_subtitle">我们的发展历程</h2>
				<!--发展历史开始-->
				<!-- <section class="aboutus_history">
					福能心理医院的前身是创立于1993年的福能总院心理科，是省内首家提供心理治疗的专业医疗机构，拥有省内最多的注册督导师、心理师。目前已经开展
					咨询服务、心理师专业培训、企业员工帮助计划（EAP）等。未来，福能心理医院除了继续提供原有的心理医疗服务之外，将计划建设心理（精神）专科医院，特设儿童治疗中心、睡眠障碍治疗中心、进食障碍治疗中心、创伤治疗中心、重症情感障碍及精神分裂症治疗康复中心。
				</section> -->
				<section class="achievement">
					<ul class="achievement_container clearfix">
						<li>
							<div class="ietm_top">2018<span>年</span></div>
							<div class="ietm_title">公司成立时间</div>
						</li>
						<!-- <li>
							<div class="ietm_top">1582<span>万</span></div>
							<div>服务用户</div>
						</li> 
						<li>
							<div class="ietm_top">324<span>+</span></div>
							<div>专家团队</div>
						</li> -->
						<li>
							<div class="ietm_top">60<span>+</span></div>
							<div>合作客户</div>
						</li>
						<li>
							<div class="ietm_top">50<span>+</span></div>
							<div>项目研究成果</div>
						</li>
					</ul>
				</section>
				<!--发展历史结束-->
				<!--发展历程开始-->
				<section class="stamp clearfix">
					<div class="stamp_left">
						<img src="~@/assets/image/aboutus_img3.jpg" alt="" width="300" height="198" />
						<div class="event">
							<div class="data">2020年</div>
							<div class="content">精准自动喂料系统研发成功，能源管理系统研发成功</div>
						</div>
						<img src="~@/assets/image/aboutus_img4.png" alt="" width="300" height="198" class="" />
					</div>
					<div class="stamp_middle">
						<img src="~@/assets/image/aboutus_img_middle.png" alt="" width="14" height="598" class="title-img" />
					</div>
					<div class="stamp_right">
						<div class="event">
							<div class="data">2018年2月</div>
							<div class="content">福建省越盛智能科技有限公司成立</div>
						</div>
						<img src="~@/assets/image/aboutus_img2.png" alt="" width="300" height="198" class="title-img" />
						<div class="event">
							<div class="data">2022年</div>
							<div class="content">全自动智能布料小车研发成功</div>
						</div>
					</div>
				</section>
				<!--发展历程结束-->
			</div>

		</section>

	</div>
</template>

<script>
	import changeNav from '@/components/changeNav.vue';
	import Carousel from '@/components/Carousel.vue';
	import Breadcrumb from '@/components/Breadcrumb.vue';
	export default {
		name: "AboutUs",
		metaInfo: {
			title: '福建省越盛智能科技有限公司', // set a title
			meta: [{ // set meta
				name: '越盛智能、全自动智能布料小车、无功补偿、无人值守智能称重、视觉智能检测、能源在线监测、智能配料、自动喂料系统、自动喂养系统、智能饲养系统、养猪场喂料设备、养鸡场自动喂料系统、自动化养殖设备、智能喂养系统、智能称重喂养系统、自动称重喂养设备',
				content: '关于我们'
			}],
			link: [{ // set link
				rel: 'asstes',
				href: 'http://www.fjyszn.com/'
			}]
		},
		components: {
			changeNav,
			Carousel,
			Breadcrumb
		},
		data() {
			return {
				// imgUrl:require("../../assets/image/aboutus_img1.png")
			}
		},
		async mounted() {
			this.srollToTotp();
		},
		methods: {
			srollToTotp() {
				window.pageYOffset ? window.pageYOffset = 0 : document.documentElement.scrollTop ? document.documentElement.scrollTop =
					0 : document.body.scrollTop ? document.body.scrollTop = 0 : null;
			}
		}
	}
</script>

<style scoped lang="less">
	.title-box {
		text-align: left;
		height: 80px;
		line-height: 80px;

		img {
			vertical-align: middle;
		}

		span {
			vertical-align: middle;
			color: #CCC;
			font-size: 16px;
			display: inline-block;
			margin-left: 15px;
			line-height: 24px;
			margin-top: 10px;
		}
	}

	.aboutus_top {
		background-color: #fff;
		text-align: center;
		width: 1240px;
		height: 375px;
		margin: 0px auto;
	}

	.aboutus_title {
		font-size: 40px;
		font-weight: 600;
		color: rgba(51, 51, 51, 1);
		line-height: 48px;
		margin-bottom: 20px;
	}

	.aboutus_subtitle {
		font-size: 28px;
		font-weight: 600;
		color: rgba(51, 51, 51, 1);
		line-height: 34px;
		margin-bottom: 70px;
	}

	.aboutus_content {
		font-size: 18px;
		font-weight: 400;
		color: rgba(128, 128, 128, 1);
		line-height: 33px;
		text-align: left;
	}

	.aboutus_img {
		margin-top: 60px;
		margin-bottom: 90px;
	}

	.showdow {
		width: 830px;
		height: 381px;
		box-shadow: 0px 20px 30px #ccc;
	}

	.strategy {
		width: 438px;
		height: 311px;
		margin: 0 auto;
		position: relative;
		text-align: center;

		.strategy-img {
			position: absolute;
		}

		.strategy-img1 {
			top: 10px;
			left: 0px;
		}

		.strategy-img2 {
			top: 100px;
			left: -40px;
		}

		.strategy-img3 {
			top: 188px;
			left: -80px;
		}

		.strategy-img4 {
			top: 277px;
			left: -120px;
		}
	}

	.strategy-left {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 150px;
		text-align: center;

		.strategy-text {
			position: absolute;
			left: 84px;
			top: -4px;
			font-size: 24px;
			font-weight: 600;
			color: rgba(0, 142, 191, 1);
			line-height: 30px;

			font {
				font-size: 12px;
				font-weight: 400;
				line-height: 16px;
			}
		}

		.strategy-text1 {
			top: -4px;
			color: #2C9C44;
		}

		.strategy-text2 {
			top: 86px;
			color: #008EBF;
			left: 28px;
		}

		.strategy-text3 {
			top: 174px;
			color: #D55020;
			left: -18px;
		}

		.strategy-text4 {
			top: 263px;
			color: #793684;
			left: -65px;
		}
	}

	.strategy-right {
		position: absolute;
		top: 0;
		right: 0;
		text-align: left;
		font-size: 16px;
		font-weight: 400;
		color: rgba(102, 102, 102, 1);
		line-height: 20px;

		.strategy_txt {
			position: absolute;
			width: 350px;
		}

		.strategy_txt_1 {
			top: 8px;
			left: -158px;
		}

		.strategy_txt_2 {
			top: 98px;
			left: -118px;
		}

		.strategy_txt_3 {
			top: 185px;
			left: -75px;
		}

		.strategy_txt_4 {
			top: 273px;
			left: -38px;
		}
	}


	.aboutus_bottom {
		background-color: #F2F2F2;

		.aboutus_subtitle {
			padding-top: 80px;
		}

		.aboutus_bottom_container {
			width: 1240px;
			margin: 0 auto;
		}

		.abuout_container {
			width: 1240px;
		}

		.aboutus_history {
			font-size: 14px;
			font-weight: 400;
			color: rgba(128, 128, 128, 1);
			line-height: 25px;
		}

		.achievement {
			margin-top: 80px;

		}

		.achievement_container {
			width: 1310px;
			overflow: hidden;

			li {
				float: left;
				width: 200px;
				height: 200px;
				border-radius: 50%;
				border: 1px solid #ccc;
				margin-left: 110px;
				margin-right: 110px;
				text-align: center;
			}

			.ietm_top {
				font-size: 44px;
				font-weight: 600;
				color: rgba(51, 51, 51, 1);
				line-height: 54px;
				margin-top: 60px;

				span {
					font-size: 14px;
					font-weight: 400;
					color: rgba(102, 102, 102, 1);
					line-height: 18px;
				}
			}

			.ietm_title {
				font-size: 14px;
				font-weight: 400;
				color: rgba(102, 102, 102, 1);
				line-height: 18px;
			}
		}

		.stamp {
			width: 916px;
			margin: 85px 40px 0px auto;
			height: 762px;

			.stamp_left {
				float: left;
				text-align: right;

				.event {
					margin: 97px 0px;
				}
			}

			.stamp_middle {
				float: left;
				margin: 28px;
			}

			.stamp_right {
				float: left;
				text-align: left;

				.title-img {
					margin: 100px 0px;
				}
			}

			.data {
				font-size: 20px;
				font-weight: 600;
				color: rgba(51, 51, 51, 1);
				line-height: 24px;
			}

			.content {
				font-size: 14px;
				font-weight: 400;
				color: rgba(128, 128, 128, 1);
				line-height: 18px;
				margin-top: 6px;
			}
		}


	}
</style>
